
/* injects from baggage-loader */
var Template = require('./template.js');

import { Component } from "react";
import PropTypes from "prop-types";

class AsianGameListCompetition extends Component {
    shouldComponentUpdate (nextProps) {
        let allowRender = (nextProps.competition[nextProps.competition.key].length !== this.props.competition[this.props.competition.key].length);
        return allowRender;
    }
    render () {
        return Template.default.apply(this); //eslint-disable-line no-undef
    }
}

AsianGameListCompetition.propTypes = {
    competition: PropTypes.object
};

export default AsianGameListCompetition;